import { Modal } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { SHARE_CODE_URL } from '../../../../shared/env';
import { BlueRoundedButton } from '../../common/components/BlueRoundedButton';
import {
  CloseButtonContainer,
  ModalCloseButton,
} from '../../common/components/ModalCloseButton';
import { Spacer } from '../../common/components/Spacer';
import { TermText } from '../../common/components/styledComponents';

const ModalBack = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  width: 550px;
  max-width: 95%;
  background: white;
  box-sizing: border-box;
  padding: 100px 90px 60px;

  ${p =>
    p.theme.isMobile &&
    `
    padding: 100px 60px 60px;
    `}
`;

const ModalTitle = styled.div`
  font-size: 32px;
  line-height: 35px;
  text-align: center;
  font-weight: 500;
  color: #666973;
`;

const CodeContainer = styled.div`
  margin-top: 9px;
  margin-bottom: 9px;
  width: 100%;
`;

const CodeElement = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 6);
  box-sizing: border-box;
  padding: 14px 18px;
  border: 1px solid #ededed;
  font-size: 39px;

  ${p =>
    p.theme.isMobile &&
    `
    padding: 14px 8px;
    `}
`;

const LinkButton = styled.div`
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  color: #2e5be0;
  margin-top: 9px;
  cursor: pointer;
`;

const MessageText = styled(TermText)`
  text-align: center;
`;

interface ShareCodeModalProps {
  open: boolean;
  onClose: () => void;
  code: string;
}
export const ShareCodeModal = (props: ShareCodeModalProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.sendImages.share.modal',
  });
  const { open, onClose, code } = props;

  const shareCodeHost = new URL(SHARE_CODE_URL).hostname;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <ModalBack>
        <CloseButtonContainer>
          <ModalCloseButton onClick={onClose} />
        </CloseButtonContainer>
        <ModalTitle>{`${t('title')}`}</ModalTitle>
        <CodeContainer>
          {Array.from(Array(code.length).keys()).map(i => (
            <CodeElement key={i}>{code.charAt(i)}</CodeElement>
          ))}
        </CodeContainer>
        <TermText>{t('terms.0')}</TermText>
        <BlueRoundedButton marginTop="61px" onClick={onClose}>
          {t('closeButton')}
        </BlueRoundedButton>
        <Spacer height={51} />
        <MessageText>{t('terms.1')}</MessageText>
        <div onClick={() => window.open(SHARE_CODE_URL, '_blank')}>
          <LinkButton>{shareCodeHost}</LinkButton>
        </div>
      </ModalBack>
    </Modal>
  );
};
